import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  hint?: string;
  addonRight?: ReactNode;
}

const FormField = forwardRef<HTMLInputElement, Props>(
  ({ label, error, hint, addonRight, className = '', ...rest }, ref) => {
    return (
      <div className={className}>
        <label className="field-label">{label}</label>
        <div className="relative">
          <input ref={ref} className={`field-input ${addonRight ? 'pr-10' : ''}`} {...rest} />
          {addonRight && (
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 text-neutral-500 dark:text-neutral-400">
              {addonRight}
            </div>
          )}
        </div>
        {hint && !error && <p className="mt-1 text-xs text-neutral-500 dark:text-neutral-400">{hint}</p>}
        {error && <p className="field-error">{error}</p>}
      </div>
    );
  }
);
FormField.displayName = 'FormField';
export default FormField;
